module.exports = __webpack_public_path__ + "img/afrus_logo_3.5dba538f.png";